import { render, staticRenderFns } from "./OptionCategoryRow.vue?vue&type=template&id=3e051d96&scoped=true&"
import script from "./OptionCategoryRow.vue?vue&type=script&lang=js&"
export * from "./OptionCategoryRow.vue?vue&type=script&lang=js&"
import style0 from "./OptionCategoryRow.vue?vue&type=style&index=0&id=3e051d96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e051d96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VEditDialog,VIcon,VTextField})
